import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'
import { sha256 } from 'js-sha256'
import { logEvent } from 'firebase/analytics'

// Routes
import { canNavigate } from '@/libs/acl/routeProtection'
// eslint-disable-next-line import/no-cycle
import {
  isUserLoggedIn, getUser, getHomeRouteForLoggedInUser, saveLoginRedirect,
} from '@/auth/utils'

// import apps from './routes/apps'
// import dashboard from './routes/dashboard'
// import uiElements from './routes/ui-elements/index'
// import pages from './routes/pages'
// import chartsMaps from './routes/charts-maps'
// import formsTable from './routes/forms-tables'
// import others from './routes/others'

// eslint-disable-next-line import/extensions
import SettingsProfileInformation from '@/views/settings/components/ProfileInformation'
// eslint-disable-next-line import/extensions
import SettingsUpdatePassword from '@/views/settings/components/UpdatePassword'
// eslint-disable-next-line import/extensions
import SettingsNotifications from '@/views/settings/components/Notifications'
// eslint-disable-next-line import/extensions
import SettingsInterests from '@/views/settings/components/Interests'
// eslint-disable-next-line import/extensions
import SettingsFilters from '@/views/settings/components/Filters'
// eslint-disable-next-line import/extensions
import SettingsAboutUs from '@/views/settings/components/AboutUs'
// eslint-disable-next-line import/extensions
import SettingsContact from '@/views/settings/components/Contact'
// eslint-disable-next-line import/extensions
import SettingsContracts from '@/views/settings/components/Contracts'
// eslint-disable-next-line import/extensions
import SettingsRemoveAccount from '@/views/settings/components/RemoveAccount'
// eslint-disable-next-line import/extensions
import SettingsSSS from '@/views/settings/components/SSS'
// eslint-disable-next-line import/extensions
import SettingsCalling from '@/views/settings/components/Calling'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior(to) {
    // Hukuki sayfalarda #hash ile gelinen bölüm sayfa içinde kaydırılıyor
    if (to.hash && (to.name === 'legal.report' || to.name === 'legal.document')) return false
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/r/:code',
      name: 'referral-landing',
      component: () => import('@/views/referral/ReferralLanding.vue'),
      meta: { layout: 'full', public: true },
    },
    // Hukuki merkez, sözleşmeler ve içerik bildirimi (footer bağlantıları) — giriş gerektirmez.
    // Uygulamanın kendi düzeninde (üst menü + footer) açılır.
    {
      path: '/legal',
      name: 'legal',
      component: () => import('@/views/legal/LegalCenter.vue'),
      meta: { public: true, legal: true },
    },
    {
      path: '/legal/:slug',
      name: 'legal.document',
      component: () => import('@/views/legal/LegalDocument.vue'),
      meta: { public: true, legal: true },
    },
    {
      path: '/report',
      name: 'legal.report',
      component: () => import('@/views/legal/Report.vue'),
      meta: { public: true, legal: true },
    },
    { path: '/sozlesmeler', redirect: { name: 'legal' } },
    // Giriş ekranındaki sözleşme bağlantıları: üye olmayanlar için, uygulama menüsü olmadan açılan sayfa
    {
      path: '/agreements/:doc?',
      name: 'public-legal',
      component: () => import('@/views/legal/LoginLegalModal.vue'),
      props: route => ({ page: true, initialDoc: route.params.doc || null }),
      meta: { layout: 'full', public: true },
    },
    { path: '/kayit-ol', redirect: { name: 'auth-login' } },
    { path: '/kesfet', redirect: { name: 'popular-users' } },
    { path: '/uye-arama', redirect: { name: 'search-users' } },
    { path: '/yeni-uyeler', redirect: { name: 'new-users' } },
    { path: '/populer-uyeler', redirect: { name: 'popular-users' } },
    { path: '/goruntulu-uyeler', redirect: { name: 'video-call-users' } },
    { path: '/sana-ozel', redirect: { name: 'for-you' } },
    { path: '/yakindakiler', redirect: { name: 'near-by' } },
    { path: '/bagli-kullanicilar', redirect: { name: 'online-users' } },
    { path: '/mesajlas/:userId?', redirect: { name: 'chat' } },
    { path: '/etkilesim', redirect: { name: 'interaction.likes' } },
    { path: '/aramalar', redirect: { name: 'calls.voice' } },
    // Hediye satışı kaldırıldı
    // { path: '/hediyelerim', redirect: { name: 'gifts' } },
    { path: '/satinalinanmedya', redirect: { name: 'buying-contents' } },
    { path: '/kazanimlar', redirect: { name: 'gains' } },
    { path: '/ayarlar', redirect: { name: 'settings' } },
    { path: '/ayarlar/profil-bilgileri', redirect: { name: 'settings.profile-information' } },
    { path: '/ayarlar/sifre-degistirme', redirect: { name: 'settings.update-password' } },
    { path: '/ayarlar/hakkimizda', redirect: { name: 'settings.about-us' } },
    { path: '/ayarlar/iletisim', redirect: { name: 'settings.contact' } },
    { path: '/ayarlar/uyelik-sozlesmeleri', redirect: { name: 'settings.contracts' } },
    { path: '/ayarlar/ilgi-alanlari', redirect: { name: 'settings.interests' } },
    { path: '/ayarlar/filtreleme', redirect: { name: 'settings.filters' } },
    { path: '/ayarlar/hesap-silme', redirect: { name: 'settings.remove-account' } },
    { path: '/ayarlar/sss', redirect: { name: 'settings.faq' } },
    { path: '/ayarlar/bildirimler', redirect: { name: 'settings.notifications' } },
    { path: '/ayarlar/aranma-ayarlari', redirect: { name: 'settings.calling' } },
    { path: '/profil/:id', redirect: { name: 'users.show' } },
    { path: '/profil', redirect: { name: 'profile.index' } },
    { path: '/uyeler', redirect: { name: 'near' } },
    { path: '/bakim-modu', redirect: { name: 'maintenance-mode' } },

    { path: '/', name: 'index' },
    {
      path: '/search',
      name: 'search-users',
      component: () => import('@/views/users/SearchUsers.vue'),
    },
    {
      path: '/new-users',
      name: 'new-users',
      component: () => import('@/views/users/NewUsers.vue'),
    },
    {
      path: '/popular-users',
      name: 'popular-users',
      redirect: { name: 'moments', query: { tab: 'discoverygrid' } },
    },
    {
      path: '/video-call-users',
      name: 'video-call-users',
      component: () => import('@/views/users/VideoCallUsers.vue'),
    },
    {
      path: '/for-you',
      name: 'for-you',
      redirect: { name: 'moments', query: { tab: 'foryou' } },
    },
    {
      path: '/nearby',
      name: 'near-by',
      component: () => import('@/views/users/NearByUsers.vue'),
    },
    {
      path: '/online-users',
      name: 'online-users',
      component: () => import('@/views/discover/OnlineUsers.vue'),
    },
    {
      path: '/chat/:userId?',
      name: 'chat',
      component: () => import('@/views/chat/Index.vue'),
      meta: {
        contentRenderer: 'sidebar-left',
        contentClass: 'chat-application',
      },
    },
    {
      path: '/payment/products/:productId',
      name: 'buy',
      component: () => import('@/views/market/Buy.vue'),
    },
    {
      path: '/payment/credit-card/finalize',
      name: 'payment.finalize',
      component: () => import('@/views/market/Finalize2.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/payment/credit-card/finalize-craftgate',
      name: 'payment.finalize-craftgate',
      component: () => import('@/views/market/FinalizeCraftgate.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/market',
      name: 'market',
      component: () => import('@/views/market/Index.vue'),
    },
    {
      path: '/market/dynamic',
      name: 'market-dynamic',
      component: () => import('@/views/market/MarketEntry.vue'),
    },
    // {
    //     path: '/interaction',
    //     name: 'interaction',
    //     component: () => import('@/views/interaction/Index.vue'),
    // },
    {
      path: '/likes',
      name: 'interaction.likes',
      component: () => import('@/views/interaction/Likes.vue'),
    },
    {
      path: '/liked',
      name: 'interaction.liked',
      component: () => import('@/views/interaction/Liked.vue'),
    },
    {
      path: '/blocked',
      name: 'interaction.blocked',
      component: () => import('@/views/interaction/Blocked.vue'),
    },
    {
      path: '/calls',
      name: 'calls',
      component: () => import('@/views/calls/Index.vue'),
    },
    {
      path: '/voice-calls',
      name: 'calls.voice',
      component: () => import('@/views/calls/Voice.vue'),
    },
    {
      path: '/video-calls',
      name: 'calls.video',
      component: () => import('@/views/calls/Video.vue'),
    },
    // Hediye satışı kaldırıldı — hediyeler sayfası devre dışı
    // {
    //   path: '/gifts',
    //   name: 'gifts',
    //   component: () => import('@/views/gifts/Index.vue'),
    // },
    // {
    //   path: '/purchased-media',
    //   name: 'buying-contents',
    //   component: () => import('@/views/buying-contents/Index.vue'),
    // },
    {
      path: '/account-status',
      name: 'account-status',
      component: () => import('@/views/account-status/Index.vue'),
    },
    {
      path: '/gains',
      name: 'gains',
      component: () => import('@/views/gains/Index.vue'),
    },
    {
      path: '/cashouts',
      name: 'cashouts',
      component: () => import('@/views/cashouts/Index.vue'),
    },
    {
      path: '/rewards',
      name: 'rewards',
      component: () => import('@/views/rewards/Index.vue'),
      meta: {
        skin: 'boho-dark',
      },
    },
    {
      path: '/rewards-mobile',
      name: 'rewards-mobile',
      component: () => import('@/views/rewards/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
        skin: 'boho-dark',
      },
    },
    {
      path: '/tasks',
      name: 'tasks',
      component: () => import('@/views/tasks/Index.vue'),
      meta: {
        skin: 'tasks-dark',
      },
    },
    {
      path: '/tasks-mobile',
      name: 'tasks-mobile',
      component: () => import('@/views/tasks/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
        skin: 'tasks-dark',
      },
    },
    {
      path: '/account-status-mobile',
      name: 'account-status-mobile',
      component: () => import('@/views/account-status/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/cashouts-mobile',
      name: 'cashouts-mobile',
      component: () => import('@/views/cashouts/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/gains-mobile',
      name: 'gains-mobile',
      component: () => import('@/views/gains/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/mobile-tools',
      name: 'mobile-tools',
      component: () => import('@/views/mobile/tools/Index.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/bonus-campaign',
      name: 'bonus-campaign',
      component: () => import('@/views/mobile/bonus-campaign/Index.vue'),
    },
    {
      path: '/mobile-bonus-campaign',
      name: 'mobile-bonus-campaign',
      component: () => import('@/views/mobile/bonus-campaign/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/bonus-outcall',
      name: 'bonus-outcall',
      component: () => import('@/views/mobile/bonus-outcall/Index.vue'),
    },
    {
      path: '/mobile-bonus-outcall',
      name: 'mobile-bonus-outcall',
      component: () => import('@/views/mobile/bonus-outcall/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/campaigns',
      name: 'campaigns',
      component: () => import('@/views/mobile/campaigns/Index.vue'),
    },
    {
      path: '/campaigns-mobile',
      name: 'campaigns-mobile',
      component: () => import('@/views/mobile/campaigns/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/for-you-2',
      name: 'for-you-2',
      component: () => import('@/views/mobile/for-you/Index.vue'),
    },
    {
      path: '/mobile-for-you',
      name: 'mobile-for-you',
      component: () => import('@/views/mobile/for-you/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/tawk-chat',
      name: 'tawk-chat',
      component: () => import('@/views/mobile/tawk-chat/Mobile.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/moments',
      name: 'moments',
      component: () => import('@/views/moments/Index.vue'),
      meta: {
        contentClass: 'moments-application',
      },
    },
    {
      path: '/video-room/:channelId/:agoraUid',
      name: 'video-room',
      component: () => import('@/views/video-room/Index.vue'),
    },
    {
      path: '/video-room/setup',
      name: 'video-room-setup',
      component: () => import('@/views/video-room/Setup.vue'),
    },
    {
      path: '/voice-room/setup',
      name: 'voice-room-setup',
      component: () => import('@/views/voice-room/Setup.vue'),
    },
    {
      path: '/voice-room/:channelId',
      name: 'voice-room',
      component: () => import('@/views/voice-room/Index.vue'),
    },
    {
      path: '/settings',
      name: 'settings',
      component: () => import('@/views/settings/Index.vue'),
      redirect: { name: 'settings.profile-information' },
      children: [
        {
          path: 'profile-information',
          name: 'settings.profile-information',
          component: SettingsProfileInformation,
        },
        {
          path: 'update-password',
          name: 'settings.update-password',
          component: SettingsUpdatePassword,
        },
        {
          path: 'about-us',
          name: 'settings.about-us',
          component: SettingsAboutUs,
        },
        {
          path: 'contact',
          name: 'settings.contact',
          component: SettingsContact,
        },
        {
          path: 'membership-agreements',
          name: 'settings.contracts',
          component: SettingsContracts,
        },
        {
          path: 'interests',
          name: 'settings.interests',
          component: SettingsInterests,
        },
        {
          path: 'filters',
          name: 'settings.filters',
          component: SettingsFilters,
        },
        {
          path: 'remove-account',
          name: 'settings.remove-account',
          component: SettingsRemoveAccount,
        },
        {
          path: 'faq',
          name: 'settings.faq',
          component: SettingsSSS,
        },
        {
          path: 'notifications',
          name: 'settings.notifications',
          component: SettingsNotifications,
        },
        {
          path: 'calling',
          name: 'settings.calling',
          component: SettingsCalling,
        },
        {
          path: 'blocked',
          name: 'settings.blocked',
          component: () => import('@/views/interaction/Blocked.vue'),
        },
        // Hediye satışı kaldırıldı — ayarlar altındaki hediyeler devre dışı
        // {
        //   path: 'gifts',
        //   name: 'settings.gifts',
        //   component: () => import('@/views/gifts/Index.vue'),
        // },
      ],
    },
    {
      path: '/profile/:type?/:id',
      name: 'users.show',
      component: () => import('@/views/users/Show.vue'),
    },
    {
      path: '/profile',
      name: 'profile.index',
      // Profil sayfası ayarlar > profil bilgileri ile birleştirildi
      redirect: { name: 'settings.profile-information' },
    },
    {
      path: '/live',
      name: 'live.index',
      component: () => import('@/views/live/Index.vue'),
      meta: {
        skin: 'boho-dark',
      },
    },
    {
      path: '/face-detection',
      name: 'face-detection.index',
      component: () => import('@/views/face-detection/Index.vue'),
    },
    {
      path: '/login',
      name: 'auth-login',
      component: () => import('@/views/authentication/Login.vue'),
      meta: {
        layout: 'full',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/eglenceli-sohbet',
      name: 'lp1',
      component: () => import('@/views/lps/Lp1.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/sohbet-keyfi',
      name: 'lp2',
      component: () => import('@/views/lps/Lp2.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/canli-muhabbet',
      name: 'lp3',
      component: () => import('@/views/lps/Lp3.vue'),
      redirect: { name: 'lp3.step-1' },
      children: [
        {
          path: '1',
          name: 'lp3.step-1',
          component: () => import('@/views/lps/lp3/Step1.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 1,
          },
        },
        {
          path: '2',
          name: 'lp3.step-2',
          component: () => import('@/views/lps/lp3/Step2.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 2,
          },
        },
        {
          path: '3',
          name: 'lp3.step-3',
          component: () => import('@/views/lps/lp3/Step3.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 3,
          },
        },
        {
          path: '4',
          name: 'lp3.step-4',
          component: () => import('@/views/lps/lp3/Step4.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 4,
          },
        },
        {
          path: '5',
          name: 'lp3.step-5',
          component: () => import('@/views/lps/lp3/Step5.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 5,
          },
        },
        {
          path: 'products',
          name: 'lp3.step-6',
          component: () => import('@/views/lps/lp3/Products.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 6,
          },
        },
        {
          path: 'payment',
          name: 'lp3.step-7',
          component: () => import('@/views/lps/lp3/Payment.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 7,
          },
        },
      ],
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/sohbet-diyari',
      name: 'lp4',
      component: () => import('@/views/lps/Lp4.vue'),
      redirect: { name: 'lp4.step-1' },
      children: [
        {
          path: '1',
          name: 'lp4.step-1',
          component: () => import('@/views/lps/lp3/Step5.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 1,
          },
        },
        {
          path: '2',
          name: 'lp4.step-2',
          component: () => import('@/views/lps/lp3/Step4.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 2,
          },
        },
        {
          path: '3',
          name: 'lp4.step-3',
          component: () => import('@/views/lps/lp3/Step1.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 3,
          },
        },
        {
          path: '4',
          name: 'lp4.step-4',
          component: () => import('@/views/lps/lp3/Step2.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 4,
          },
        },
        {
          path: '5',
          name: 'lp4.step-5',
          component: () => import('@/views/lps/lp3/Step3.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 5,
          },
        },
        {
          path: '6',
          name: 'lp4.step-6',
          component: () => import('@/views/lps/lp3/Step4.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 6,
          },
        },
        {
          path: 'products',
          name: 'lp4.step-7',
          component: () => import('@/views/lps/lp3/Products.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 7,
          },
        },
        {
          path: 'payment',
          name: 'lp4.step-8',
          component: () => import('@/views/lps/lp3/Payment.vue'),
          meta: {
            layout: 'full',
            resource: 'Auth',
            public: true,
            step: 8,
          },
        },
      ],
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/lps-payment-finalize',
      name: 'lps-payment-finalize',
      component: () => import('@/views/lps/PaymentFinalize.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/users',
      name: 'public-users',
      component: () => import('@/views/users/Public.vue'),
      meta: {
        layout: 'full-container',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/maintenance-mode',
      name: 'misc-under-maintenance',
      component: () => import('@/views/miscellaneous/UnderMaintenance.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/error',
      name: 'misc-error',
      component: () => import('@/views/miscellaneous/Error.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '/not-authorized',
      name: 'misc-not-authorized',
      component: () => import('@/views/miscellaneous/NotAuthorized.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/error-404',
      name: 'error-404',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        action: 'read',
      },
    },
    {
      path: '/rive',
      name: 'rive',
      component: () => import('@/views/Rive.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/face-zoom',
      name: 'face-zoom',
      component: () => import('@/views/FaceZoom.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/paywall',
      name: 'paywall',
      component: () => import('@/views/Paywall.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '/yourturnnow',
      name: 'public-form1',
      component: () => import('@/views/public/Form1.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        public: true,
      },
    },
    {
      path: '*',
      redirect: 'error-404',
    },
  ],
})

let tawkToOnLoaded = false

router.beforeEach((to, from, next) => {
  if (to.query && typeof to.query.r === 'string' && /^[A-Za-z0-9]{6}$/.test(to.query.r)) {
    document.cookie = `referral_code=${encodeURIComponent(to.query.r)}; Max-Age=${60 * 60 * 24 * 14}; Path=/; SameSite=Lax`
  }

  if (to.meta.public) {
    return next()
  }

  const isLoggedIn = isUserLoggedIn()

  if (!isLoggedIn && to.name === 'users.show' && typeof to.query.r === 'string' && /^[A-Za-z0-9]{6}$/.test(to.query.r)) {
    // Davet linkiyle gelen profil: girişten sonra o profile dönülür
    saveLoginRedirect(to)
    return next({ name: 'auth-login', query: { lang: to.query.lang || to.params.lang } })
  }

  // if (!isLoggedIn) return next({ name: 'auth-login' })

  if (!isLoggedIn && to.name === 'index') {
    return next({ name: 'auth-login' })
  } if (isLoggedIn && to.name === 'index') {
    return next({ name: 'moments' })
  }

  if (!canNavigate(to)) {
    // Redirect to login if not logged in
    if (!isLoggedIn && to.name !== 'auth-login') {
      saveLoginRedirect(to)
      return next({ name: 'auth-login', query: { lang: to.params.lang } })
    }

    // If logged in => not authorized
    return next({ name: 'misc-not-authorized' })
  }

  // Redirect if logged in
  if (to.meta.redirectIfLoggedIn && isLoggedIn) {
    const user = getUser()
    next(getHomeRouteForLoggedInUser(user ? user.role : null))

    return next({ name: 'moments', query: { lang: to.params.lang } })
  }

  if (!to.meta.redirectIfLoggedIn && !isLoggedIn && to.name !== 'auth-login') {
    saveLoginRedirect(to)
    return next({ name: 'auth-login', query: { lang: to.params.lang } })
  }

  // Kullanıcı hesap durumu sayfasına gitmek istiyor ama gitmesine yetkisi yoksa
  if (to.name === 'account-status' && store.getters['auth/userGender'] !== 'female' && !store.getters['auth/freeCallUser']) {
    return next({ name: 'moments' })
  }

  // Kullanıcı kazanımlar sayfasına gitmek istiyor ama gitmesine yetkisi yoksa
  if (to.name === 'gains' && store.getters['auth/userGender'] !== 'female' && !store.getters['auth/freeCallUser']) {
    return next({ name: 'moments' })
  }

  // Kullanıcı çekimler sayfasına gitmek istiyor ama gitmesine yetkisi yoksa
  if (to.name === 'cashouts' && store.getters['auth/userGender'] !== 'female' && !store.getters['auth/freeCallUser']) {
    return next({ name: 'moments' })
  }

  // Kullanıcı ödüller sayfasına gitmek istiyor ama gitmesine yetkisi yoksa
  if (to.name === 'rewards' && store.getters['auth/userGender'] !== 'female' && !store.getters['auth/freeCallUser']) {
    return next({ name: 'moments' })
  }

  // Kullanıcı yeni-uyeler sayfasına gitmek istiyor ama gitmesine yetkisi yoksa
  // if (to.name === 'popular-users' && store.getters['auth/userGender'] !== 'female') {
  //     next({name: 'moments'})
  // }

  // Kullanıcı bagli-uyeler sayfasına gitmek istiyor ama gitmesine yetkisi yoksa
  if (to.name === 'online-users' && store.getters['auth/userGender'] !== 'female') {
    return next({ name: 'moments' })
  }

  // Kullanıcı market sayfasına gitmek istiyor ama gitmesine yetkisi yoksa
  if (to.name === 'market' && store.getters['auth/userGender'] === 'female') {
    // return next({ name: 'moments' })
  }

  return next()
})

// ? For splash screen
// Sayfanın ilk (varsayılan) sekme başlığı. Hukuki sayfalar başlığı kendileri değiştiriyor ama çıkışta geri
// almıyordu; başlık diğer sayfalarda da "Hukuki Merkez · Boho" kalıyordu. Her geçişte varsayılana dönülür,
// kendi başlığını yazan sayfalar bunu açıldıklarında yine üzerine yazar.
const defaultDocumentTitle = document.title

// Remove afterEach hook if you are not using splash screen
router.afterEach((to, from) => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }

  if (to.path !== from.path) {
    document.title = defaultDocumentTitle
  }

  if (window.firebaseAnalytics) {
    // Sayfa görüntüleme event'i gönder
    logEvent(window.firebaseAnalytics, 'page_view', {
      page_path: to.path,
      page_name: to.name,
      page_title: to.meta.title || document.title,
      page_location: window.location.href,
      previous_page: from.path,
    })

    // Debug için
    if (process.env.NODE_ENV === 'development') {
      console.log('📊 Page View Event:', {
        from: from.path,
        to: to.path
      })
    }
  }

  const user = getUser()

  if (user) {
    // Tawk.to scripti index.html'de kapalı olduğunda Tawk_API tanımsız; kontrol etmeden yazmak her geçişte hata fırlatıyordu
    if (!tawkToOnLoaded && window.Tawk_API) {
      window.Tawk_API.onLoad = function() {
        tawkToOnLoaded = true
      }
    }
  }

  let tawkToData = {}
  if (user) {
    const tawkToApiKey = process.env.VUE_APP_TAWKTO_API_KEY || '58c155d1e79c1935a0df0a6af68767f732eb0fea'
    const hash = sha256.hmac(tawkToApiKey, user.email || '')
    tawkToData = {
      name: user.userName,
      username: user.userName,
      email: user.email || '',
      hash,
    }
  }

  if (window.Tawk_API) {
    if (tawkToOnLoaded) {
      if (tawkToData && window.Tawk_API.setAttributes) {
        // Kullanıcı verilerini tawk.to'ya ata
        window.Tawk_API.setAttributes(tawkToData, error => {
          console.log(error)
        })
      }

      // Eğer chat veya payment.finalize sayfasındaysak tawk.to'yu gizle
      if (['chat', 'payment.finalize', 'tawk-chat', 'tasks', 'tasks-mobile', 'auth-login'].includes(to.name)) {
        if (window.Tawk_API.hideWidget) window.Tawk_API.hideWidget()
      } else if (window.Tawk_API.showWidget) {
        window.Tawk_API.showWidget()
      }
    } else {
      window.Tawk_API.onLoad = function() {
        tawkToOnLoaded = true

        if (tawkToData && window.Tawk_API.setAttributes) {
          // Kullanıcı verilerini tawk.to'ya ata
          window.Tawk_API.setAttributes(tawkToData, error => {
            console.log(error)
          })
        }

        // Eğer chat veya payment.finalize sayfasındaysak tawk.to'yu gizle
        if (['chat', 'payment.finalize', 'tawk-chat', 'tasks', 'tasks-mobile', 'auth-login'].includes(to.name)) {
          if (window.Tawk_API.hideWidget) window.Tawk_API.hideWidget()
        } else if (window.Tawk_API.showWidget) {
          window.Tawk_API.showWidget()
        }
      }
    }
  }
})

export default router
